import { BOOKING_VIEWPORT_DRAG_THRESHOLD_PX } from "../Domain/Constants/floorPlanBookingTouch.constants";
import { PlanViewMode } from "../Components/PixiViewport/PixiViewport";

export function resolveViewportDragThreshold(planViewMode: PlanViewMode): number | undefined {
  if (planViewMode === PlanViewMode.BOOKING) {
    return BOOKING_VIEWPORT_DRAG_THRESHOLD_PX;
  }

  return undefined;
}
